import React from "react";
import clock1 from "../assets/portfolio/bewkoof.png";
import installNode from "../assets/portfolio/installNode.jpg";
import navbar from "../assets/portfolio/navbar.jpg";
import Netflix from "../assets/portfolio/shop.png";
import clock from "../assets/portfolio/zostel.png";
import reactSmooth from "../assets/portfolio/reactSmooth.jpg";
import reactWeather from "../assets/portfolio/reactWeather.jpg";
import "../components/Portfolio.css";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: clock,
      live: "https://649172d26d0e81146d11731e--timely-shortbread-695a01.netlify.app/",
      code: "https://github.com/PriyanshuAppa24/Analog-Clock",
      title: "Digital Clock",
      techstack: "HTML | CSS | Mongo DB",
      feature1:"This is a digital clock made using HTML and CSS",
      feature2:"This website is hosted using Netlify",
      feature3:"You can use it as your desktop clock, or you can use it on a website"
    },

    {
      id: 2,
      src: Netflix,
      live: "https://6491782f19606d1686d18bbc--sensational-toffee-a086f8.netlify.app/",
      code: "https://github.com/PriyanshuAppa24/Netflix-Clone",
      title: "Netflix CLONE",
      //description:
       // "Netflix Clone",
      techstack: "HTML | CSS | JavaScript",
      feature1: "User can Sign in & Sign up",
      feature2: "User can apply filter and can search about the different shows",
      feature3: "You can buy different subscription based on your preference",
    },
    {
      id: 3,
      src: clock1,
      live: "https://64917c746d0e811b56116f9f--roaring-sable-365b65.netlify.app/",
      code: "https://github.com/PriyanshuAppa24/Analog-Clock",
      title: "Analog Clock",
      //description:
        //"Bewakoof is India’s largest Casual Wear and Lifestyle Brand and E-commerce platform.",
      techstack: "HTML | CSS |Javascript",
    
      feature1: "This is a Analog clock made using HTML, CSS and Javascript",
      feature2: "This website is hosted using Netlify",
      feature3: "You can use it as your desktop clock, or you can use it on a website",
    },
  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-fit"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-fit">
        <div className="pb-8" style={{ marginTop: "100px" }}>
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div
          className="grid sm:grid-cols-2 md:grid-cols-2 gap-8 px-12 sm:px-0"
          id="mainContainer"
        >
          {portfolios.map(
            ({
              id,
              src,
              live,
              code,
              title,
              description,
              techstack,
              feature1,
              feature2,
              feature3,
              feature4,
            }) => (
              <div
                key={id}
                className="shadow-md shadow-gray-600 rounded-lg"
                id="container"
              >
                <img
                  src={src}
                  alt=""
                  className="rounded-md duration-200 hover:scale-105"
                  id="container-img"
                />
                <div id="container-profile">
                  <h1>{title}</h1>
                  <p>{description}</p>
                  <p>Tech stack : {techstack}</p>
                  <ul>
                    {" "}
                    Feature
                    <li className="container-li">{feature1}</li>
                    <li className="container-li">{feature2}</li>
                    <li className="container-li">{feature3}</li>
                    {feature4 ? (
                      <li className="container-li">{feature4}</li>
                    ) : null}
                  </ul>
                  <div id="container-button">
                    <a href={live} target="blank">
                      <button className="w-10  py-3 m-4 duration-200 text-center hover:scale-105 hover:border-b-4 border-indigo-500">
                        Live
                      </button>
                    </a>
                    <a href={code} target="blank">
                      <button className="w-1/2 px-0 py-3 m-4 duration-200 hover:scale-105 hover:border-b-4 border-indigo-500">
                        Code
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
